import { render, staticRenderFns } from "./ScheduleMatchCenter.vue?vue&type=template&id=b68aaf5e&scoped=true&"
import script from "./ScheduleMatchCenter.vue?vue&type=script&lang=js&"
export * from "./ScheduleMatchCenter.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleMatchCenter.vue?vue&type=style&index=0&id=b68aaf5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68aaf5e",
  null
  
)

export default component.exports